import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UploadMediaModule } from '../upload-media/upload-media.module';
import { TooltipInputModule } from '../tooltip-input/tooltip-input.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

import { FeaturedTourCreatorComponent } from './featured-tour-creator.component';

@NgModule({
    declarations: [
        FeaturedTourCreatorComponent
    ],
    imports: [
        CommonModule,
        UploadMediaModule,
        TooltipInputModule,
        FormsModule,
        SvgIconModule
    ],
    exports: [
        FeaturedTourCreatorComponent
    ]
})
export class FeaturedTourCreatorModule { }
